import React, { useState } from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ArcaPdfStudioLayout from '../../components/arca/ArcaPdfStudioLayout';
import { appendUploadFiles } from '../../components/arca/uploadItemUtils';
import { getToken } from '../../api/client';
import API_CONFIG from '../../config/api';

function isWordFile(file) {
  return (
    file &&
    (/\.(docx?)$/i.test(file.name || '') ||
      /word|msword|officedocument\.wordprocessingml/i.test(file.type || ''))
  );
}

function baixarBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default function ArcaPdfWordParaPdfPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const file = items[0]?.file || null;

  const handleFilesAdd = (files) => {
    setError('');
    const n = appendUploadFiles(files, setItems, { multiple: false, filter: isWordFile });
    if (!n) setError('Selecione um arquivo Word (.doc ou .docx).');
  };

  const handleConvert = async () => {
    setError('');
    if (!file) {
      setError('Envie um arquivo Word.');
      return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('file', file, file.name);
      const token = getToken();
      const res = await fetch(`${API_CONFIG.BACKEND_URL}/api/arca/pdf/convert/word-to-pdf`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd,
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Erro na conversão (${res.status}).`);
      }
      const blob = await res.blob();
      const disposition = res.headers.get('Content-Disposition') || '';
      const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
      const filename = match
        ? decodeURIComponent(match[1].replace(/"/g, ''))
        : `documento-${Date.now()}.pdf`;
      baixarBlob(blob, filename);
    } catch (e) {
      console.error('[ArcaPdfWordParaPdf]', e);
      setError(e.message || 'Erro ao converter.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ArcaPdfStudioLayout
      title="Word para PDF"
      info="Converte .doc/.docx em PDF no servidor (LibreOffice). Clique no card para tentar visualizar."
      limits={
        <>
          Formatos: .doc / .docx · máx. <strong>50 MB</strong>. Opcional:{' '}
          <code>LIBREOFFICE_PATH</code> no <code>backend/.env</code>.
        </>
      }
      error={error}
      onClearError={() => setError('')}
      items={items}
      setItems={setItems}
      loading={loading}
      enableRotate={false}
      enableSortAlpha={false}
      dropzone={{
        accept:
          '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        multiple: false,
        maxSizeMb: 50,
        onFilesAdd: handleFilesAdd,
        label: 'Arraste um Word ou clique para selecionar',
        hint: 'Formatos: .doc / .docx · máx. 50MB',
      }}
      actionLabel="Converter e baixar PDF"
      actionLoadingLabel="Convertendo…"
      actionStartIcon={<DescriptionOutlinedIcon />}
      onAction={handleConvert}
      actionDisabled={!file}
    />
  );
}
